function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { createMachine } from '@minutemailer/state';
import generateKey from "./lib/generateKey";
export default createMachine('notifications', {
  state: {
    current: 'ready',
    notifications: []
  },
  transitions: {
    setNotifications: {
      from: 'ready',
      to: 'ready'
    },
    addNotification: {
      from: 'ready',
      to: 'adding-notification'
    },
    notificationAdded: {
      from: 'adding-notification',
      to: 'ready'
    },
    removeNotification: {
      from: 'ready',
      to: 'removing-notification'
    },
    notificationRemoved: {
      from: 'removing-notification',
      to: 'ready'
    }
  },
  handlers: {
    onAddingNotification: function onAddingNotification(title, content) {
      var action = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var onClick = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var key = generateKey();
      this.notificationAdded({
        notifications: [].concat(_toConsumableArray(this.state.notifications), [{
          key: key,
          title: title,
          content: content,
          action: action,
          onClick: onClick
        }])
      });
    },
    onRemovingNotification: function onRemovingNotification(id) {
      var index = this.state.notifications.findIndex(function (el) {
        return el.key === id;
      });
      var notifications = _toConsumableArray(this.state.notifications);
      if (index > -1) {
        notifications.splice(index, 1);
      }
      this.notificationRemoved({
        notifications: notifications
      });
    }
  }
});